import { render } from "./App.vue?vue&type=template&id=2e3a7d81&scoped=true"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"

import "./App.vue?vue&type=style&index=0&id=2e3a7d81&lang=scss"
import "./App.vue?vue&type=style&index=1&id=2e3a7d81&scoped=true&lang=scss"

import exportComponent from "/double-take/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2e3a7d81"]])

export default __exports__